import axios from 'axios';
import * as uuid from 'uuid';
import TagFormat from '../../utils/tagFormat';

export interface TagBulk {
  id: string,
  tagLabel: string,
  format: TagFormat,
  formatCheck?: number,
  required: boolean,
  value: string,
  count?: number,
  type?: string,
}

export interface GetTagBulkForm {
  documentList?: TagBulkDocumentListItem[]
  ccControlNumberList?: TagBulkCcControlNumberListItem[]
}

export interface GetTagBulkResponse {
  tagList: {
    tagLabel: string,
    format: TagFormat,
    formatCheck?: number,
    count: number,
    require: boolean,
  }[]
}

export interface TagBulkDocumentListItem {
  documentId: number,
}

export interface TagBulkCcControlNumberListItem {
  ccControlNumber: number,
}

export interface UpdateTagBulkForm {
  documentList: TagBulkDocumentListItem[],
  tagList: TagBulk[]
}

export default {
  async getTagBulk(form: GetTagBulkForm): Promise<TagBulk[]> {
    const res = await axios.post<GetTagBulkResponse>('/BulkTagChange/getTags', form);
    const { data } = res;
    const tagList = data.tagList.map((tag) => ({
      ...tag, id: uuid.v1(), value: '', required: tag.require,
    }));
    return tagList;
  },
  async updateTagBulk(form: UpdateTagBulkForm): Promise<void> {
    return axios.post('/BulkTagChange/updateAll', {
      documentList: form.documentList,
      tagList: form.tagList.map((tag) => ({
        tagLabel: tag.tagLabel,
        format: tag.format,
        formatCheck: tag.formatCheck ?? 0,
        value: TagFormat.normalizeTagValue(tag.format, tag.value),
      })),
    });
  },
};
